import React, { useEffect, useState } from 'react'
import { UserContextProvider } from '../context/UserContext'
import Layout from '../components/Layout'
import { toast } from 'react-toastify'
import { getDetailNews, updateNews } from '../services/news.service'
import { useNavigate, useParams } from 'react-router-dom'
import BeritaForm from '../sections/BeritaForm'
import { AxiosError } from 'axios'

const EditBerita = () => {
  const [data, setData] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()
  const params = useParams()

  const onSubmit = async (e) => {
    try {
      setIsLoading(true)
      e.preventDefault()
      const data = new FormData(e.target)
      await updateNews({ id: params?.id, form: data })
      toast.success('Berhasil mengupdate berita')
      navigate('/konten/berita')
    } catch (error) {
      toast.error(error?.response?.data?.error?.message ?? 'Error')
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    const fetch = async () => {
      try {
        setIsLoading(true)
        const data = await getDetailNews({ id: params?.id })
        setData(data?.data ?? null)
      } catch (error) {
        let message = "There's something error. Please try again later."
        if (error instanceof AxiosError) {
          message =
            error.response.data?.error?.message ??
            "There's something error. Please try again later."
        }
        toast.error(message, {
          toastId: message,
        })
      } finally {
        setIsLoading(false)
      }
    }
    fetch()
  }, [])

  if (data === null || isLoading) {
    return <></>
  }

  return (
    <UserContextProvider>
      <Layout
        activeNav="Berita"
        isBackButtonShown={true}
        isDetailShown={true}
        detail={data}
        isPreviewShown={true}
        previewComponent={
          <div>
            <p className="font-semibold text-[28px] my-4">Preview</p>
            <img
              src={
                'https://nos.wjv-1.neo.id/jakmania-bucket/assets/Tutor%20CMS/News/News-x3.png'
              }
              className="object-contain mx-auto w-[210px] h-[480px] mb-4"
            />
            <p className="font-normal text-[16px]">Deskripsi</p>
            <p className="opacity-70 text-[14px] mb-4">
              Perubahan pada berita akan mempengaruhi detail Jakmania Kini,
              berita yang kamu upload nanti akan masuk ke aplikasi the Jakmania.
            </p>
            <p className="font-normal text-[16px]">Ribbon</p>
            <p className="opacity-70 text-[14px] mb-4">
              Tulisan yang akan muncul di depan berita{' '}
            </p>
          </div>
        }
      >
        <BeritaForm onSubmit={onSubmit} data={data} isLoading={isLoading} />
      </Layout>
    </UserContextProvider>
  )
}

export default EditBerita
